import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
    let output = [];
    if (data) {
        let property = {};
        property["paymentData"] = data;
        output.push(property);
    }
    return output;
}

function Properties(args) {
    let editable = args.editable ? true : false;
    return {
        paymentData: {
            alias: "paymentData",
            type: "text",
            editable,
        }
    };
}


const Payment = {
    auth: "",
    views: {
        list: {
            apis: {
                view: {
                    url: "{path}",
                    method: "GET",
                    replace: {
                        path: function () {
                            let url = new URL(window.location.href);
                            let param = url.searchParams.get("merchantRef");

                            if (window.location.href.indexOf("success") > -1 || window.location.href.indexOf("fail") > -1) {
                                return "/page/payment/complete?merchantRef=" + param;
                            }
                            return ""
                        },
                    },
                    mapper: Mapper,
                },
            },
            template: "payment",
            templateConfiguration: {
                includeProperties: [],
                excludeProperties: [],
                events: { onClick: function (e) {} },
            },
            properties: Properties({ editable: false }),
            primaryKey: "id",
        },
    },
};

export default Payment;
